import { pushToDataLayer } from '../../pushToDataLayer';
import { GTMEvent, GTMEventAttributes, GTMEventName } from '../../types';

export function startRecordingEvent() {
  const eventAttributes: GTMEventAttributes = {
    event: GTMEvent.COVIDEO_EVENT,
    event_name: GTMEventName.START_RECORDING,
  };

  pushToDataLayer({
    ...eventAttributes,
  });
}
